import { Button, Icon, ListItem, ListItemSecondaryAction, Typography } from '@mui/material';
import { styled, alpha } from '@mui/material/styles';

export const Container = styled('div')(({ theme }) => ({
  padding: theme.spacing(1),
}));

export const StyledListItem = styled(ListItem, {
  shouldForwardProp: (prop) => prop !== 'isHeader',
})(({ theme, isHeader }) => ({
  [theme.breakpoints.down('sm')]: {
    marginBottom: theme.spacing(1),
    paddingRight: theme.spacing(2),
    paddingLeft: 0,
  },
  borderBottom: `2px solid ${alpha(theme.palette.action.disabledBackground, 0.05)}`,
  ...(isHeader
    ? {
        borderBottom: 'none',
        // Desktop only: flush with checkbox column. Keep default gutters on small
        // screens so this matches the tasks/list row layout.
        [theme.breakpoints.up('sm')]: {
          paddingLeft: 0,
        },
      }
    : {}),
}));

export const ListItemHeader = styled('div')({
  fontSize: 20,
  fontWeight: 'bold',
});

export const ListItemSecondary = styled('div', {
  shouldForwardProp: (prop) => prop !== 'isHeader',
})(({ theme, isHeader }) => ({
  [theme.breakpoints.down('sm')]: {
    marginLeft: theme.spacing(-3.5),
    marginTop: theme.spacing(isHeader ? 3 : 2),
  },
}));

export const ListItemActions = styled(ListItemSecondaryAction)(({ theme }) => ({
  right: theme.spacing(1),
  [theme.breakpoints.down('sm')]: {
    top: 'inherit',
    bottom: theme.spacing(-3.5),
  },
}));

export const GreyIcon = styled(Icon)(({ theme }) => ({
  color: theme.palette.text.disabled,
  width: theme.spacing(2),
  height: theme.spacing(2),
}));

export const OrangeIcon = styled(Icon)(({ theme }) => ({
  color: theme.palette.warning.main,
  width: theme.spacing(2),
  height: theme.spacing(2),
}));

export const RedIcon = styled(Icon)(({ theme }) => ({
  color: theme.palette.error.main,
  width: theme.spacing(2),
  height: theme.spacing(2),
}));

export const StyledAvatar = styled(Icon, {
  shouldForwardProp: (prop) => prop !== 'isHeader',
})(({ theme, isHeader }) => ({
  alignSelf: 'flex-start',
  backgroundColor: 'transparent',
  color: theme.palette.text.primary,
  margin: theme.spacing(1),
}));

export const DatesText = styled(Typography)({
  fontSize: 13,
});

export const IssueBtn = styled(Button, {
  shouldForwardProp: (prop) => !['isHeader', 'selected'].includes(prop),
})(({ theme, isHeader, selected }) => ({
  backgroundColor: theme.palette.action.disabledBackground,
  pointerEvents: isHeader ? 'auto' : 'none',
  width: 65,
  height: 65,
  marginLeft: 5,
  flexDirection: 'column',
  color: theme.palette.text.primary,
  fontSize: 12,

  '&:hover': {
    backgroundColor: alpha(theme.palette.secondary.main, 0.5),
  },

  ...(selected ? { backgroundColor: alpha(theme.palette.secondary.main, 0.5) } : {}),
}));

export const RowFlex = styled('div')({
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'flex-start',
});

export const UpdatedCol = styled('div')(({ theme }) => ({
  width: 110,
  [theme.breakpoints.down('sm')]: {
    width: 80,
  },
}));

export const CreateButton = styled(Button)(({ theme }) => ({
  marginRight: theme.spacing(1),
  marginLeft: 'auto',
}));
